import React, { useRef, useEffect } from 'react';
// import { ReactComponent as Logo } from '../images/logo.svg';
import { dispatch } from 'use-bus';

const SearchBar = (props: any) => {
    const tailwindVersion = "1.0.2";
    const searchInput: any = useRef(null);

    useEffect(() => {
        searchInput.current.focus();
    });

    return (
        <div className="bg-white border-b lg:fixed lg:w-full lg:top-0 lg:left-0">
            <div className="container p-4 mx-auto">
                <div className="flex flex-col lg:items-center lg:justify-center lg:flex-row lg:space-x-4">
                    <div className="flex flex-col items-center sm:flex-row sm:justify-center">                        
                        <h1 className="flex items-center pl-2 mt-2 text-lg text-gray-600 lg:mt-0 sm:ml-2 font-semibold">Google Analytics 4 Measurement Protocol <span className="flex items-center h-5 px-2 ml-2 text-xs font-bold text-gray-500 rounded-md bg-yellow-300">{tailwindVersion}</span> <small>(19th Sep 2022)</small></h1>
                    </div>

                    <input ref={searchInput} className="h-10 mt-4 border-gray-200 rounded-md lg:mt-0 lg:w-96 focus:border-teal-500 focus:ring focus:ring-primary focus:ring-opacity-40" type="text" placeholder="Search" onChange={props.search} />

                    <div className="flex flex-col mt-4 space-y-3 lg:mt-0 sm:flex-row sm:space-y-0 sm:space-x-3 sm:items-center sm:justify-center">
                        <button onClick={() => dispatch('ui/expand')} className="px-4 py-2 space-x-3 text-gray-600 transition-colors duration-200 transform border rounded-lg hover:bg-gray-100 focus:outline-none">Expand <span className="lg:hidden 2xl:inline">All</span></button>
                        <button onClick={() => dispatch('ui/collapse')} className="px-4 py-2 space-x-3 text-gray-600 transition-colors duration-200 transform border rounded-lg hover:bg-gray-100 focus:outline-none">Collapse <span className="lg:hidden 2xl:inline">All</span></button>
                        <a title="David Vallejo" href="https://www.thyngster.com/" className="px-4 py-2 font-semibold text-center text-black rounded-md bg-yellow-300 hover:bg-teal-300">by thyngster.<span className="lg:hidden xl:inline">com</span></a>
                    </div>
                </div>
            </div>                                    
            <div className="container mb-4 mx-auto">
            <div className="bg-white text-center py-1 lg:px-1">
            <div className="flex items-center bg-blue-500 text-white text-sm font-semibold px-4 py-3" role="alert">
                <svg className="fill-current w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z"/></svg>
                <p>This is an non-official documentation. Definition may change in the future with no further notification</p>
            </div>


                <div className="bg-white text-center">
                        <a href="https://www.thyngster.com/app-web-google-analytics-measurement-protocol-version-2">Example of sending data to the public GA4 endpoint <span role="img">🔗</span></a>
                    </div>
                    </div>

                <div className="text-xs"></div>
            </div>
        </div>
        
    );
};

export default SearchBar;
